export const version = "signing-key/5.6.2";
//# sourceMappingURL=_version.js.map